import { HttpService } from '@/data/http/http-service';
import { CalculateTour } from '@/domain/impact-calculate-tour/entities/calculate-tour.entity';
import { ImpactCalculateTourGateway } from '@/domain/impact-calculate-tour/gateways/impact-calculate-tour.gateway';

import { resultsTourDtoSchema } from './results/dto.type';
import { ResultsTourMapper } from './results/mapper';

export class ApiImpactCalculateTourHttpGateway implements ImpactCalculateTourGateway {
  private httpProject = new HttpService({
    baseURL: import.meta.env.VITE_API_PROJECT,
  });
  private httpImpact = new HttpService({
    baseURL: import.meta.env.VITE_API_IMPACT,
  });

  // project-tour CO2

  async runImpactCalculateTourCo2ForProject(projectId: number): Promise<void> {
    const url = '/calculate/co2/tour';
    const data = { tourId: projectId };
    const response = await this.httpImpact.post(url, data);
    if (response.status === 201) {
      return;
    } else {
      throw 'error run impact calculate co2 for tour';
    }
  }

  // tour-sequence CO2

  async runImpactCalculateTourCo2ForSequence(
    sequenceId: number,
  ): Promise<void> {
    const url = '/calculate/co2/tour-sequence';
    const data = { sequenceId };
    const response = await this.httpImpact.post(url, data);
    if (response.status === 201) {
      return;
    } else {
      throw 'error run impact calculate co2 for tour sequence';
    }
  }

  // project-tour ENV

  async runImpactCalculateTourEnvForProject(projectId: number): Promise<void> {
    const url = '/calculate/env/tour';
    const data = { tourId: projectId };
    const response = await this.httpImpact.post(url, data);
    if (response.status === 201) {
      return;
    } else {
      throw 'error run impact calculate env for tour';
    }
  }

  // project-tour ESS

  async runImpactCalculateTourEssForProject(projectId: number) {
    const url = '/calculate/ess/tour';
    const data = { tourId: projectId };
    const response = await this.httpImpact.post(url, data);
    if (response.status === 201) {
      return;
    } else {
      throw 'error run impact calculate ess for tour';
    }
  }

  // results

  async getTourResultsForProject(projectId: number): Promise<CalculateTour> {
    const url = `/results/tour/${projectId}`;
    const response = await this.httpProject.get(url);
    const result = resultsTourDtoSchema.safeParse(response.data);
    if (result.success === false) {
      console.error(result.error);
      throw result.error;
    }
    const calculateTour = ResultsTourMapper.dtoToEntity(result.data);
    return calculateTour;
  }
}
